import React from 'react';
import { Layout, Row, Col, Divider, Typography, Space } from 'antd';
import {
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
  YoutubeOutlined,
  InstagramOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  HeartFilled
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Text, Link, Title } = Typography;

const FooterBar = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  const footerStyle = {
    backgroundColor: '#f0f2f5',
    padding: '40px 0 20px',
    color: '#333',
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px',
  };

  const sectionTitleStyle = {
    color: '#1890ff',
    marginBottom: '16px',
    fontWeight: 600,
  };

  const linkStyle = {
    color: '#555',
    transition: 'color 0.3s',
  };

  const iconStyle = {
    fontSize: '20px',
    color: '#555',
    transition: 'color 0.3s',
    ':hover': {
      color: '#1890ff',
    },
  };

  const dividerStyle = {
    margin: '24px 0',
    borderColor: '#d9d9d9',
  };

  const copyrightStyle = {
    color: '#666',
    fontSize: '14px',
  };

  return (
    <Layout.Footer style={footerStyle}>
      <div style={containerStyle}>
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={sectionTitleStyle}>
              Quick Links
            </Title>
            <Space direction="vertical" size="middle">
              <Link onClick={()=> navigate('/home')} style={linkStyle}>Home</Link>
              <Link onClick={()=> navigate('/about-us')} style={linkStyle}>Company</Link>
              <Link onClick={()=> navigate('/services')} style={linkStyle}>Services</Link>
              <Link onClick={()=> navigate('/internship')} style={linkStyle}>Internship</Link>
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>Get In Touch</Link>
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>Career</Link>
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={sectionTitleStyle}>
              Support
            </Title>
            <Space direction="vertical" size="middle">
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>FAQ</Link>
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>Help Center</Link>
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>Contact Us</Link>
              <Link onClick={()=> navigate('/privacy-policy-for-24care.ae')} style={linkStyle}>Privacy Policy</Link>
              <Link onClick={()=> navigate('/get-in-touch')} style={linkStyle}>Terms of Service</Link>
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={sectionTitleStyle}>
              Contact Info
            </Title>
            <Space direction="vertical" size="middle">
              <Text>
                <PhoneOutlined style={{ marginRight: '8px', color: '#1890ff' }} /> 
                +91-9591184926 / +91-9980570819
              </Text>
              <Text>
                <MailOutlined style={{ marginRight: '8px', color: '#1890ff' }} /> 
                info@shreeshtech.com
              </Text>
              <Text>
                <EnvironmentOutlined style={{ marginRight: '8px', color: '#1890ff' }} /> 
                Door No.4, 3rd Floor, Prestige Towers, Moodbidri, Mangalore, Karnataka - India
              </Text>
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} style={sectionTitleStyle}>
              Follow Us
            </Title>
            <Space size="large">
              <Link href="https://www.facebook.com/shreeshtech" target="_blank" rel="noopener noreferrer">
                <FacebookOutlined style={iconStyle} />
              </Link>
              <Link href="https://www.linkedin.com/company/shreeshtech" target="_blank" rel="noopener noreferrer">
                <LinkedinOutlined style={iconStyle} />
              </Link>
              {/* <Link href="#" target="_blank" rel="noopener noreferrer">
                <YoutubeOutlined style={iconStyle} />
              </Link> */}
              <Link href="https://www.instagram.com/shreeshtech/" target="_blank" rel="noopener noreferrer">
                <InstagramOutlined style={iconStyle} />
              </Link>
            </Space>
          </Col>
        </Row>

        <Divider style={dividerStyle} />

        <Row justify="space-between" align="middle">
          <Col>
            <Text style={copyrightStyle}>
              © {currentYear} Powered by ShreeshTech. All rights reserved.
            </Text>
          </Col>
          <Col>
            <Text style={copyrightStyle}>
              Made with <HeartFilled style={{ color: '#ff4d4f' }} /> by Shreesh Tech
            </Text>
          </Col>
        </Row>
      </div>
    </Layout.Footer>
  );
};

export default FooterBar;